/**
 * Converts waypoint offsets to IntersectionObserver rootMargin format
 */
export function calculateRootMargin(
	topOffset: number | string,
	bottomOffset: number | string,
	horizontal = false,
): string {
	const start = formatOffset(topOffset);
	const end = formatOffset(bottomOffset);

	// rootMargin format: "top right bottom left"
	// For waypoint behavior, we negate the offsets
	if (horizontal) {
		// For horizontal: topOffset = leftOffset, bottomOffset = rightOffset
		return `0px -${end} 0px -${start}`;
	}
	return `-${start} 0px -${end} 0px`;
}

function formatOffset(offset: number | string): string {
	if (typeof offset === 'number') {
		return `${offset}px`;
	}
	return offset;
}
